module.exports = __webpack_public_path__ + "img/debtPayingAbility8.1716e747.png";